module.exports = __webpack_public_path__ + "static/img/20250324185059.6390d85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20250324185059.png
// module id = EpN9
// module chunks = 1